import { FC } from "react";

import __ from "web/Layout/Translations";

interface IAdditionalInfoProps {
  className: string;
}

const AdditionalInfo: FC<IAdditionalInfoProps> = ({ className }) => {
  return (
    <p className={className}>
      {__(`Infolinia 22 242 42 42, czynna 7.00 – 22.00, 7 dni w tygodniu z
    wyłączeniem dni ustawowo wolnych od pracy.`)}
    </p>
  );
};

export default AdditionalInfo;
